export const UCAT_SECTION_CONFIG = {
  vr: { label: 'Verbal Reasoning', maxRaw: 44 },
  dm: { label: 'Decision Making', maxRaw: 47 },
  qr: { label: 'Quantitative Reasoning', maxRaw: 36 },
};

export const UCAT_SCALED_MIN = 300;
export const UCAT_SCALED_MAX = 900;
export const UCAT_TOTAL_MIN = 900;
export const UCAT_TOTAL_MAX = 2700;
export const UCAT_SJT_MAX_RAW = 69;

export function estimateSjtBand(rawMark) {
  if (rawMark === '' || rawMark == null) return null;

  const raw = Number(rawMark);
  if (!Number.isFinite(raw)) {
    throw new TypeError('rawMark must be a finite number');
  }

  const clampedRaw = Math.min(UCAT_SJT_MAX_RAW, Math.max(0, Math.round(raw)));
  if (clampedRaw >= 57) return 'Band 1';
  if (clampedRaw >= 42) return 'Band 2';
  if (clampedRaw >= 28) return 'Band 3';
  return 'Band 4';
}

export function estimateSectionScore(rawMark, maxRawMark) {
  const raw = Number(rawMark);
  const max = Number(maxRawMark);

  if (!Number.isFinite(raw) || !Number.isFinite(max) || max <= 0) {
    throw new TypeError('rawMark and maxRawMark must be finite numbers');
  }

  const clampedRaw = Math.min(max, Math.max(0, Math.round(raw)));
  const unrounded = 300 + (clampedRaw / max) * 600;
  const roundedToTen = Math.round(unrounded / 10) * 10;

  return Math.min(900, Math.max(300, roundedToTen));
}

export function estimateTotalScore({ vr, dm, qr }, sectionConfig = UCAT_SECTION_CONFIG) {
  const sectionScores = {
    vr: estimateSectionScore(vr, sectionConfig.vr.maxRaw),
    dm: estimateSectionScore(dm, sectionConfig.dm.maxRaw),
    qr: estimateSectionScore(qr, sectionConfig.qr.maxRaw),
  };

  return {
    sectionScores,
    total: sectionScores.vr + sectionScores.dm + sectionScores.qr,
  };
}
